import { ALL_VERIFY_ITEMS } from './checklists';

const d = (n) => {
  const t = new Date();
  t.setDate(t.getDate() + n);
  return t.toISOString().slice(0, 10);
};

const chk = (at, note = '') => ({ checked: true, checkedAt: at, note });
const allChecked = (at) =>
  Object.fromEntries(ALL_VERIFY_ITEMS.map((i) => [i.key, chk(at)]));

export function buildDemoState() {
  const vendors = [
    { id: 'v-wo', name: 'Vendor Contoh — Wedding Organizer', category: 'WO', pic: 'Mbak Laras', phone: '0812-3456-7890', value: 60000000, notes: 'Paket full day, 2 koordinator lapangan.', website: '@contoh.wo', location: 'Bandung', createdAt: d(-30), demo: true },
    { id: 'v-cat', name: 'Vendor Contoh — Catering', category: 'Catering', pic: 'Pak Hendra', phone: '0813-2222-1111', value: 35000000, notes: '500 pax, menu sudah shortlist.', website: '', location: 'Bandung', createdAt: d(-24), demo: true },
    { id: 'v-ven', name: 'Vendor Contoh — Venue', category: 'Venue', pic: 'Ibu Sari', phone: '022-555-0101', value: 25000000, notes: 'Gedung + taman, kapasitas 600.', website: '', location: 'Bandung', createdAt: d(-28), demo: true },
    { id: 'v-fot', name: 'Vendor Contoh — Foto & Video', category: 'Foto & Video', pic: 'Mas Bimo', phone: '0857-9999-0000', value: 15000000, notes: '2 fotografer + 1 videografer + same day edit.', website: '@contoh.foto', location: 'Jakarta', createdAt: d(-14), demo: true },
  ];

  const verifications = {
    'v-wo': {
      nama_bisnis: chk(d(-9), 'Nama pada identitas sesuai informasi vendor.'),
      pic_jelas: chk(d(-9), 'PIC utama: Mbak Laras, komunikasi via WhatsApp.'),
      kontak_aktif: chk(d(-8), 'Nomor merespons cepat pada jam kerja.'),
      lokasi: chk(d(-8), 'Kantor di Bandung, pernah dikunjungi.'),
      nama_penerima: chk(d(-4), 'Rekening tercatat atas nama vendor.'),
      portfolio_dilihat: chk(d(-6), '3 acara terbaru dicatat.'),
      acara_terbaru: chk(d(-6), 'Acara Mei–Juli bisa ditelusuri di Instagram.'),
      scope: chk(d(-5), 'Scope tertulis: akad + resepsi, full koordinasi.'),
      deliverables: chk(d(-5), '2 koordinator, rundown, technical meeting.'),
      jadwal_kerja: chk(d(-5), 'Technical meeting H-30 dan H-7.'),
      nominal_sesuai: chk(d(-4), 'Total Rp60.000.000 sesuai penawaran.'),
      rek_penerima: chk(d(-4), 'Rekening bank dicatat di catatan vendor.'),
    },
    'v-cat': {
      nama_bisnis: chk(d(-3)),
      kontak_aktif: chk(d(-3), 'Dihubungi via WhatsApp, respons aktif.'),
    },
    'v-ven': allChecked(d(-12)),
    'v-fot': {
      nama_bisnis: chk(d(-2)),
      pic_jelas: chk(d(-2)),
      kontak_aktif: chk(d(-2)),
    },
  };

  const payments = [
    { id: 'p-wo1', vendorId: 'v-wo', label: 'DP Tahap 1', amount: 15000000, dueDate: d(-30), status: 'paid', paidAt: d(-30), reference: 'TRF-WO-001', note: 'Bukti transfer tersimpan di WhatsApp.', createdAt: d(-30) },
    { id: 'p-ven1', vendorId: 'v-ven', label: 'Booking Venue', amount: 13000000, dueDate: d(-18), status: 'paid', paidAt: d(-18), reference: 'TRF-VEN-001', note: '', createdAt: d(-20) },
    { id: 'p-wo2', vendorId: 'v-wo', label: 'DP Tahap 2', amount: 15000000, dueDate: d(14), status: 'upcoming', createdAt: d(-30) },
    { id: 'p-cat1', vendorId: 'v-cat', label: 'DP Catering', amount: 10000000, dueDate: d(21), status: 'upcoming', createdAt: d(-10) },
    { id: 'p-fot1', vendorId: 'v-fot', label: 'DP Foto & Video', amount: 7000000, dueDate: d(26), status: 'upcoming', createdAt: d(-8) },
  ];

  const guardChecked = Object.fromEntries(
    ['kontrak_tersedia', 'scope_jelas', 'jadwal_cocok', 'nama_dicatat', 'nominal_kesepakatan', 'tahap_sesuai', 'verify_ditinjau', 'terbuka_dipahami', 'partner_konfirmasi', 'bukti_disimpan', 'tanggal_dicatat', 'nominal_dicatat', 'invoice_disimpan'].map((k) => [k, true]),
  );

  return {
    profile: { coupleName: 'Rani & Dimas', weddingDate: d(124), budget: 150000000, city: 'Bandung', demoMode: true, createdAt: d(-30) },
    vendors,
    verifications,
    payments,
    guardChecks: { 'p-wo2': guardChecked },
    tasks: [
      { id: 't-1', title: 'Finalisasi venue', category: 'Venue', targetDate: d(-15), vendorId: 'v-ven', done: true, doneAt: d(-18) },
      { id: 't-2', title: 'Konfirmasi kontrak WO', category: 'WO', targetDate: d(10), vendorId: 'v-wo', done: false },
      { id: 't-3', title: 'Review catering', category: 'Catering', targetDate: d(12), vendorId: 'v-cat', done: false },
      { id: 't-4', title: 'Jadwalkan fitting busana', category: 'Busana', targetDate: d(20), vendorId: '', done: false },
      { id: 't-5', title: 'Konfirmasi photographer', category: 'Foto & Video', targetDate: d(25), vendorId: 'v-fot', done: false },
      { id: 't-6', title: 'Final guest estimate', category: 'Lainnya', targetDate: d(30), vendorId: '', done: false },
    ],
  };
}
